<template>
  <DataTable
      :value="listDataService"
      :lazy="true"
      class="p-datatable-responsive cursor-pointer"
      data-key="id"
      @page="onPage($event)"
      :paginator="pagination"
      :totalRecords="totalRecords"
      :rows="paginationRows"
      :loading="loading"
      :first="firstRecordIndex"
      :scrollable="(scrollHeight !== '' ? true : false) "
      :scrollHeight="scrollHeight"
      :autoLayout="true"
      filterMatchMode="startsWith"
      :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS"
      :currentPageReportTemplate=" $constants.LIST_OPTION_COMMON.TEXT_TOTAL_ITEM+' {totalRecords}'"
      :paginatorTemplate="$constants.LIST_OPTION_COMMON.PAGINATOR_TEMPLATE"
  >
    <Column
        v-for="c in model.getDisplayFields()"
        :key="c.key"
        :field="getField(c)"
        :header="getLabel(c)"
        :ref="getField(c)"
        :filterMatchMode="getFilterMatch(c)"
        :sortable="getSortable(c)"
        :bodyClass="(c.class ? 'txt-' + c.class : '')"
        :bodyStyle="getBodyStyle(c)"
        :headerStyle="getHeaderStyle(c)"
        :headerClass="(c.class ? 'txt-' + c.class : '')"
    >
      <template #body="slotProps">
        <img
            v-if="getType(c) == 'Image'"
            :src="getData(c, slotProps.data)"
            style="width: 40px; height: 40px"
        />
        <div
            v-else-if="c.type == 'Text'"
            v-html="getData(c, slotProps.data)"
            :style="(c.style ? c.style : '')"
        ></div>
        <div v-else>
          <div v-if="c.custom">
            <Avatar v-if="c.custom == 'image'" :image="getData(c, slotProps.data)" size="xlarge" />
          </div>
          <span v-else v-html="getData(c, slotProps.data)" :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
        </div>
      </template>
      <template v-if="c.filter" #filter>
        <InputText
            v-if="c.filter.type == 'input'"
            type="text"
            v-model="filters[getField(c)]"
            class="p-column-filter"
            :placeholder="$CoreService.getFilterPlaceHolder(c)"
            @keyup="onFilter($event,c.filter.type,c.key)"
        />
        <Calendar
            :key="countCalendar"
            v-if="c.filter.type == 'DateRange'"
            :showOnFocus="true"
            :monthNavigator="true"
            :yearNavigator="true"
            yearRange="2000:2030"
            dateFormat="dd/mm/yyyy"
            v-model="filters[getField(c)]"
            class="p-column-filter"
            :showIcon="true"
            selectionMode="range"
            appendTo="body"
            :showClear="true"
            :showButtonBar="true"
            @clear-click="onFilter($event,c.filter.type,c.key)"
            @date-select="onFilter($event,c.filter.type,c.key)"
            :manualInput="false"
        >
          <template #footer>
            <CalendarFooter />
          </template>
        </Calendar>
      </template>
    </Column>
    <Column
        v-if="actions"
        headerStyle="width: 6em; text-align: center"
        bodyStyle="width: 6em; text-align: center; justify-content: center"
    >
      <template #body="slotProps">
        <div class="style-action-click">
          <Button
              v-for="(a, k) in actions.rows(slotProps.data)"
              :key="k"
              type="button"
              :icon="getIcon(a.icon)"
              :class="getClass(a.name)"
              :disabled="getDisabled(a.disabled)"
              style="margin: 2px"
              v-on:click="actionsClicked(k, a, slotProps)"
          ></Button>
        </div>
      </template>
      <template #header="slotProps">
        <Button
            v-if="actions.header"
            type="button"
            :icon="getIcon(actions.header.icon)"
            :class="getClass(actions.header.name)"
            v-on:click="actionsClicked(actions.header.name, actions.header, slotProps)"
        ></Button>
      </template>
    </Column>
    <template #empty>
      {{ $t('datatable.empty') }}
    </template>
    <template #loading>
      {{ $t('datatable.loading') }}
    </template>
  </DataTable>
</template>

<script>
import moment from "moment-timezone";
import ApiRepository from "@/core/ApiRepository";

export default {
  props: {
    model: Object,
    getFilterOptions: Function,
    actions: Object,
    postId: String,
  },
  data() {
    return {
      filters: {},
      filtersCustom: [],
      countCalendar: 1,
      pagination: true,
      paginationRows: this.$constants.LIST_OPTION_COMMON.PAGINATION_ROWS_DEFAULT,
      scrollHeight: '80vh',
      loading: true,
      listDataService: [],
      lazyParams: {},
      page_transaction: null,
      firstRecordIndex: 0,
      totalRecords: 0,
      time_zone_local: moment.tz.guess(true),
    };
  },
  mounted() {
    this.scrollHeight = `${(window.innerHeight * (window.innerHeight > 900 ? 70 : 55) / 100)}px`;
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
    if (!this.$commonFuction.isEmpty(this.$route.query)) {
      if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)) {
        this.page_transaction = this.$route.query.page_transaction;
        this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : this.lazyParams;
        this.firstRecordIndex = this.lazyParams.first ?? 0;
      }
    }
    this.loading = false;
    this.onLazyEvent();
  },
  methods: {
    getLabel(col) {
      return col.label || col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") return "Custom";
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") return "Image";
          return "Input";
        case "Selection":
          return "Select";
        default:
          return col.type;
      }
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "text-align:center !important;";
      if (col.width) style += "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style += "width: 4.5em !important;";
      else if (col.type === "image" || col.type === "Image") style += "width: 6em;";
      else style += "min-width: 10em;";
      return style;
    },
    getBodyStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "text-align:center; width: 4.5em !important;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      else style += "min-width: 10em;";
      return style;
    },
    getData(col, row) {
      var value = '';
      if (col.type == "Datetime" && row[col.key]) {
        value = moment(row[col.key]).tz(this.time_zone_local).format("ll HH:mm");
      } else if (col.type == "Text" && row[col.key] && row[col.key].length > 120) {
        value = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 120)) + "...";
      } else {
        value = row[col.key];
      }
      return value;
    },
    getFilterMatch(col) {
      return col.filter && col.filter.match ? col.filter.match : "startWith";
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    actionsClicked(key, action, rowData) {
      this.$emit("action-click", {
        originalEvent: event,
        action: action,
        key: key,
        data: rowData,
        lazyParams: this.lazyParams
      });
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        default:
          return "p-button-edit";
      }
    },
    async dataList(dataRequest) {
      try {
        const headers = {
          Authorization: "Bearer " + (await this.$AuthenticationApp.getToken()),
        };
        var offset = dataRequest?.first ?? 0;
        var limit = dataRequest?.rows ?? this.paginationRows;
        var payload = {
          offset,
          limit,
          post_id: this.postId,
        };
        var filters = dataRequest?.filters ?? {};
        if (filters) {
          for (const [key, value] of Object.entries(filters)) {
            payload[key] = value;
          }
        }
        var list_action_detail = await ApiRepository.post('/_api/property/get_list_property_for_sale_contact_admin', payload, {headers});
        var responseData = list_action_detail?.data?.data ?? list_action_detail?.data ?? {};
        var listData = responseData?.list_data ?? [];
        var stt = offset ?? 0;
        this.listDataService = listData.map((item) => {
          stt++;
          return {
            ...item,
            stt,
          };
        });
        this.totalRecords = responseData?.total ?? 0;
        this.$emit('loaded', responseData);
      } catch (e) {
        this.listDataService = [];
        this.totalRecords = 0;
      }
    },
    async onLazyEvent() {
      this.loading = true;
      await this.dataList(this.lazyParams);
      this.loading = false;
    },
    async onPage(event) {
      this.lazyParams = event;
      await this.onLazyEvent();
    },
    async onFilter(event, type_input, key) {
      this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input, key, this.filters);
      this.lazyParams.first = 0;
      this.firstRecordIndex = 0;
      this.lazyParams.filters = this.filtersCustom;
      await this.onLazyEvent();
    },
  }
}
</script>

<style lang="scss">
.p-datatable .p-column-filter,
.p-datatable .p-column-filter.p-dropdown,
.p-datatable .p-column-filter.p-inputtext,
.p-datatable .p-column-filter .p-inputtext,
.p-datatable .p-column-filter.p-calendar,
.p-datatable .p-column-filter.p-calendar .p-inputtext {
  width: 100% !important;
}

.p-datatable .p-column-filter.p-calendar {
  display: flex;
}

.p-datatable .p-column-filter.p-calendar .p-datepicker-trigger {
  flex: 0 0 2.357rem;
}

.p-datatable .p-column-filter {
  box-sizing: border-box;
}

.p-datatable .p-paginator {
  padding: 0 !important;
}

.p-datatable .p-paginator .p-dropdown {
  width: auto !important;
  min-width: 78px;
}
</style>
